// extracted by mini-css-extract-plugin
module.exports = {"background":"background-FNyrF","icon":"icon-XXj2q"};